import { reject, isEmpty, compose, omit } from 'ramda';

export const withBaseFilters = obj => ({
  price: {},
  modelIds: {},
  makes: {},
  year: {},
  mpg: {   },
  mileage: {  },
  interiorColors: [],
  isFreeDelivery: {},
  textSearchInput: [],
  finance: {  },
  poseData: [],
  attributes: [],
  bodyStyles: {terms: []},
  colors: {terms: []},
  features: {terms: []},
  cylinderCounts: {terms: []},
  fuelTypes: {terms: []},
  transmissions: {terms: []},
  trims: {terms: []},
  driveTypes: {terms: []},
  ...obj
});

const purgeEmptyTerms = reject(x=>isEmpty(x.terms));
const purgeOldFilters = omit(['makes']);
const purgeEmpties = compose(purgeEmptyTerms, reject(isEmpty));
const onlyDesiredFilters = compose(purgeEmpties, purgeOldFilters);

export const removeBaseFilters = obj => onlyDesiredFilters(obj);
